import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from "moment";
import { ButtonComponent } from "../../../components/Controls/Button/Button";
import * as actions from "../../../store/requests/actions";
import { avatar, men1, men2, men3, women1, women2, women3 } from "../../../utils/images";
import TableGridView from "../../../components/TableGridView";
import Filterform from "./Filterform";
import DialogComponent from "../../../components/Dialog/Dialog";
import "./style.scss";
import "../../Patients/style.scss";
import Loader from "../../../components/Loader/Loader";
import ClippedElement from "../../../components/CLippedElement";
import ConfirmDialog from "../../../components/ConfirmDialog/ConfirmDialog";
import { checkIcon } from "../../../utils/images"
import { requestStatisticsRequest } from "../../../store/dashboard/actions";


const RejectedRequests = ({ intl: { messages } }) => {
  const history = useHistory();
  const [searchValues, setSearchValues] = useState({});
  const lang = localStorage.getItem("lang") || "en";
  const loading = useSelector((state) => state.loader);
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [requestData, setRequestData] = useState({});
  const [modalType, setModalType] = useState("");
  const { requestStatistics } = useSelector((state) => state.dashboard);
  const { rejectedRequests, request } = useSelector((state) => state.requests);
  const [finishConfirmation, setFinishConfirmation] = useState(false);
  const mens = [men1, men2, men3];
  const womens = [women1, women2, women3];

  useEffect(() => {
    //rejected requests list
    dispatch(
      actions?.rejectedRequestsRequest({
        page: 1,
        requestStatus: 7,
        sort: "created_at,desc",
      })
    );
    dispatch(requestStatisticsRequest())
    return () => {
      dispatch(actions.rejectedRequestsReceive([]));
    };
  }, [dispatch]);

/*   // Handle Restore Request
  const handleConfirmRequest = (request) => {
    setIsOpen(false);
    // dispatch(actions.acceptRequestRequest({ id: request.id }));
    setFinishConfirmation(true);
  }
 */
  //table n grid view render
  const headings = [
    messages.requests.patient_name,
    messages.requests.request_date,
    messages.requests.request_channel,
    messages.requests.request_status,
    messages.requests.actions,
  ];

  const renderTableData = () => {
    return rejectedRequests?.data?.map((request, i) => {
      const { id, patient_name, created_at, request_source, request_status } = request;
      return [
        patient_name ? (
          <ClippedElement tooltipTitle={patient_name} >
            <span>{patient_name}</span>
          </ClippedElement>
        ) : (
          "-"
        ),
        created_at
          ? moment(created_at).format("DD[.]MM[.]YYYY  ,  HH:mm:ss")
          : "-",
        request_source ? request_source : "-",
        request_status ? request_status : "-",
        <ButtonComponent
          content={messages.buttons.details}
          type="button"
          classes={`cyan-button px-8`}
          handleClick={() => {
            setRequestData(request);
            setModalType("show");
            dispatch(actions.showRequestRequest(id));
            setIsOpen(true);
          }}
        />,
      ];
    });
  };

  const handlePageChange = (e, page) => {
    return dispatch(
      actions?.rejectedRequestsRequest({
        page,
        requestStatus: 7,
        sort: "created_at,desc",
        ...searchValues,
      })
    );
  };

  const onImgError = (e, x) => {
    e.target.src = avatar;
  };

  const renderGridView = () => {
    if (rejectedRequests?.data?.length > 0) {
      return rejectedRequests.data.map((request, ind) => {
        const {
          id,
          patient_name,
          created_at,
          request_source,
          request_status,
          patient_gender_type,
          request_status_name,
          patient_image,
        } = request;
        return (
          <div className="col-md-4" key={ind}>
            <div className=" grid-col">
            <div className={`grid-col-img status${request_status || 0}`}>
                {patient_image !== null ? (
                  <img
                    src={patient_image}
                    alt="patient img"
                    onError={(e) => onImgError(e)}
                  />
                ) : (
                  <img src={patient_gender_type 
                    ? patient_gender_type === 1 ? mens[Math.floor(Math.random() * mens.length)] : patient_gender_type === 2 ? womens[Math.floor(Math.random() * womens.length)] : avatar
                    : avatar} alt="avatar img" />
                )}
                <span className="status-label">{request_status_name}</span>
              </div>
              <p className="patient_name">{patient_name}</p>
              <div className="d-flex justify-content-center">
                <p className="mx-3">{request_source}</p>
                <p className="">
                {messages.requests.date}: {moment(created_at).format("DD[.]MM[.]YYYY")}
              </p>
                {/* <p className="mx-3">{request_status}</p> */}
              </div>

              <ButtonComponent
                content={messages.buttons.details}
                type="button"
                classes={`cyan-button px-8`}
                handleClick={() => {
                  setRequestData(request);
                  setModalType("show");
                  dispatch(actions.showRequestRequest(id));
                  setIsOpen(true);
                }}
              />
            </div>
          </div>
        );
      });
    } else {
      return <div className="grid_no_data">{messages.noData.no_data}</div>
    }
  };
  
  //1st modal show data
  const renderShowRequestDataModel = () => {
    return (
      <>
        <div className="col-md-12">
          <h4 className="text-center mb-10 text-bold">
           {requestData.patient_name}
          </h4>
        </div>

        <div className="col-md-6 myform-group">
          <label className={`input-label ${lang === 'ar' ? 'rtl-label' : ''}`}>{messages.requests.name}</label>
          <input
            className={"disbale-input-text-color"}
            name="patient_name"
            value={requestData.patient_name}
            disabled={true}
          />
        </div>
        <div className="col-md-6 myform-group">
          <label className={`input-label ${lang === 'ar' ? 'rtl-label' : ''}`}>{messages.requests.phone}</label>
          <input
            className={"disbale-input-text-color phone_number"}
            name="patient_phone"
            value={requestData.patient_phone}
            disabled={true}
          />
        </div>
        <div className="col-md-12 myform-group">
          <label className={`input-label ${lang === 'ar' ? 'rtl-label' : ''}`}>{messages.requests.text_msg}</label>
          <textarea
            name="msg_text"
            className={"disbale-input-text-color"}
            value={requestData.message_text}
            disabled={true}
            rows={4}
          />
        </div>
        <div className="col-md-12 myform-group-flex">
          <label className={`input-label ${lang === 'ar' ? 'rtl-label' : ''}`}>{messages.requests.request_status} :</label>
          <span>{messages.requests.rejectedRequests}</span>
        </div>
        <div className="col-md-12 myform-group">
          <label className={`input-label ${lang === 'ar' ? 'rtl-label' : ''}`}>{messages.requests.request_reason}</label>
          <input
            name="reasons"
            value={request.reject_reason_title}
            disabled={true}
          />
          <textarea
            name="reason"
            value={request.reject_reason_message}
            disabled={true}
            rows={3}
          />
        </div>
      </>
    );
  };
 
  const renderModalContent = () => {
    return (
      <div className="row px-5 py-4 justify-content-center">
        {loading ? (
          <Loader className={"loader center-vertical"} />
        ) : modalType === "show" ? (
          renderShowRequestDataModel()        
        ) : null}
      </div>
    );
  };

  return (
    <>
      {rejectedRequests ? (
        <TableGridView
          title={
            <>
              <FormattedMessage
                values={{
                  total: rejectedRequests?.total,
                  totals: requestStatistics?.rejected,
                }}
                id="requests.request_of"
                defaultMessage={messages.requests.request_of}
              />
            </>
          }
          Form={<Filterform setSearchValues={setSearchValues} />}
          table={{
            stickyHeader: true,
            headings: headings,
            data: renderTableData(),
            headClass: "bg-white table-head",
            noData: messages.noData.no_data,
          }}
          gridView={renderGridView}
          defaultView="grid"
          pagination={{
            count: rejectedRequests.last_page,
            page: rejectedRequests.current_page,
            handleChange: handlePageChange,
          }}
        />
      ) : null}
      <DialogComponent
        open={isOpen}
        handleClose={() => {
          setIsOpen(false);
        }}
        content={renderModalContent()}
      />
      <ConfirmDialog show={finishConfirmation} 
                     onCancel={() => {
                        setFinishConfirmation(false)
                      }}
                     onConfirm={() => {
                        setFinishConfirmation(false);
                        history.push("/newRequests");
                     }}
                     icon={checkIcon}
                     content={messages.requests.request_confirmation}
                     cancelBtn={messages.requests.request_confirmation_close}
                     confirmBtn={messages.requests.request_restored} />
    </>
  );
};

export default injectIntl(RejectedRequests);
